"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ChevronRightSolid_1 = __importDefault(require("../../../IconsNavigation/ChevronRightSolid"));
const useFiatCurrency_1 = __importDefault(require("../../hooks/useFiatCurrency"));
const InputLabel_1 = __importDefault(require("../InputLabel"));
const FiatList_1 = __importDefault(require("../FiatList"));
const Flag_1 = __importDefault(require("../Flag"));
const styled_1 = require("../../styled");
const styled_2 = require("./styled");
const FiatSelect = ({ label }) => {
    const [show, setShow] = (0, react_1.useState)(false);
    const fiatCurrency = (0, useFiatCurrency_1.default)();
    return (react_1.default.createElement(styled_1.Field, { style: { minWidth: 200 } },
        react_1.default.createElement(InputLabel_1.default, null, label),
        react_1.default.createElement(styled_2.SelectWrapper, { onClick: () => {
                setShow(true);
            } },
            react_1.default.createElement(styled_2.Text, null,
                fiatCurrency && (react_1.default.createElement(Flag_1.default, { country: fiatCurrency.alpha2, width: 22, height: 22 })), fiatCurrency === null || fiatCurrency === void 0 ? void 0 :
                fiatCurrency.abbr,
                react_1.default.createElement(styled_2.SubText, null,
                    "(", fiatCurrency === null || fiatCurrency === void 0 ? void 0 :
                    fiatCurrency.label,
                    ")")),
            react_1.default.createElement(ChevronRightSolid_1.default, { size: 10, color: "#0085FF" })),
        react_1.default.createElement(FiatList_1.default, { show: show, setShow: setShow })));
};
exports.default = FiatSelect;
//# sourceMappingURL=FiatSelect.js.map